
import { Component, Prop, Vue } from 'nuxt-property-decorator'

type BreadcrumbsItem = {
  label: string,
  path: string,
  active: boolean,
}

@Component
export default class StaticPageHero extends Vue {
  @Prop({ required: true }) readonly breadcrumbs!: BreadcrumbsItem[]
  @Prop({ required: true }) readonly title!: string
}
